import React from 'react'
import { Route, Navigate, useLocation } from 'react-router-dom'

import routes, { RoutedComponent } from '../../routes'
import { useAccountsQuery } from '@data/accounts/accounts'
import { useDevicesQuery } from '@data/device/device'
import { useAuthStore } from '@store/auth.store'

import { PageNotFound } from './Components/PageNotFound'
import RedirectRoute from '../../RedirectRoute'
import { SentryRoutes } from '../../App'
import { hasPermissions } from '@common/utils/validation/authValidators'

const MainContent: React.FC = () => {
  const { isLoading: devicesLoading } = useDevicesQuery()
  const { isLoading: accountsLoading } = useAccountsQuery()
  const authenticated = useAuthStore((state) => state.authenticated)
  const permissions = useAuthStore((state) => state.permissions)

  const location = useLocation()

  if (devicesLoading || accountsLoading) {
    return <div>Loading...</div>
  }

  return (
    <div
      id="main-content"
      // Reads the height AppShell computed rather than restating it, so the two cannot drift
      // apart across breakpoints — see the header config in App.tsx.
      style={{
        overflowY: 'auto',
        height: 'calc(100vh - var(--app-shell-header-height))',
        marginTop: '0',
      }}
    >
      <div
        className='container-fluid'
        style={{ height: '100%' }}
      >
        <SentryRoutes>
          <Route
            path=""
            element={
              location.state?.from ? (
                <Navigate to={location.state.from.pathname} replace />
              ) : (
                <Navigate
                  to={
                    hasPermissions(permissions, ['DASHBOARD:STATUS:VIEW'])
                      ? '/hourly-usage'
                      : '/home'
                  }
                />
              )
            }
          />
          {routes.map((routedComponent: RoutedComponent) => {
            const Component = routedComponent.component

            return (
              <Route
                key={routedComponent.path}
                path={routedComponent.path}
                element={
                  authenticated &&
                  hasPermissions([...permissions], [...routedComponent.permissions]) ? (
                    <RedirectRoute>
                      <Component />
                    </RedirectRoute>
                  ) : (
                    <Navigate to="/" replace />
                  )
                }
              >
                {routedComponent.children?.map((childrenRoute: RoutedComponent) => {
                  const ChildrenComponent = childrenRoute.component
                  return (
                    <Route
                      key={childrenRoute.path}
                      path={childrenRoute.path}
                      element={
                        <RedirectRoute>
                          <ChildrenComponent />
                        </RedirectRoute>
                      }
                    />
                  )
                })}
              </Route>
            )
          })}
          {<Route path="*" element={<PageNotFound />} />},
        </SentryRoutes>
      </div>
    </div>
  )
}

export default MainContent
